export const SmileEmoji = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 22C18.2728 22 22.75 17.5228 22.75 12C22.75 6.47715 18.2728 2 12.75 2C7.22715 2 2.75 6.47715 2.75 12C2.75 17.5228 7.22715 22 12.75 22Z"
        stroke={"#bcbcbe"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 14C8.75 14 10.25 16 12.75 16C15.25 16 16.75 14 16.75 14"
        stroke={"#bcbcbe"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 9H15.76"
        stroke={"#bcbcbe"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 9H9.76"
        stroke={"#bcbcbe"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.666504 6.49984C0.666504 6.49984 3.33317 1.1665 7.99984 1.1665C12.6665 1.1665 15.3332 6.49984 15.3332 6.49984C15.3332 6.49984 12.6665 11.8332 7.99984 11.8332C3.33317 11.8332 0.666504 6.49984 0.666504 6.49984Z"
        stroke="#4E84A1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99984 8.49984C9.10441 8.49984 9.99984 7.60441 9.99984 6.49984C9.99984 5.39527 9.10441 4.49984 7.99984 4.49984C6.89527 4.49984 5.99984 5.39527 5.99984 6.49984C5.99984 7.60441 6.89527 8.49984 7.99984 8.49984Z"
        stroke="#4E84A1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2002 9.5V12.1667C13.2002 12.5203 13.0597 12.8594 12.8097 13.1095C12.5596 13.3595 12.2205 13.5 11.8669 13.5H2.53353C2.17991 13.5 1.84077 13.3595 1.59072 13.1095C1.34067 12.8594 1.2002 12.5203 1.2002 12.1667V9.5M3.86686 6.16667L7.2002 9.5M7.2002 9.5L10.5335 6.16667M7.2002 9.5V1.5"
        stroke="#4E84A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PenIcon = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 2.50005C12.947 2.28118 13.1808 2.10756 13.4382 1.98911C13.6956 1.87066 13.9714 1.80969 14.25 1.80969C14.5286 1.80969 14.8044 1.87066 15.0618 1.98911C15.3192 2.10756 15.553 2.28118 15.75 2.50005C15.947 2.71892 16.1032 2.97875 16.2098 3.26472C16.3165 3.55069 16.3713 3.85719 16.3713 4.16671C16.3713 4.47624 16.3165 4.78274 16.2098 5.06871C16.1032 5.35468 15.947 5.61451 15.75 5.83338L5.625 17.0834L1.5 18.3334L2.625 13.75L12.75 2.50005Z"
        stroke="#4E84A1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LighteningIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8333 1.66667L2.5 11.6667H10L9.16667 18.3333L17.5 8.33334H10L10.8333 1.66667Z"
        stroke="#4E84A1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
